import React from 'react';
import { connect } from 'react-redux';
class TabWrapper extends React.Component<{}, {}> {
  constructor(props, context) {
    super(props, context);
  }
  render() {
    const { children } = this.props;
    return <div className="grid grid--narrower">{children}</div>;
  }
}
function mapStateToProps() {
  return {};
}
function mapDispatchToProps() {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TabWrapper);
